var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIconInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.998,
    viewBox: "0 0 18 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_258",
    "data-name": "Subtraction 258",
    d: "M17638.271,9060.5a2.493,2.493,0,0,1-1.781-.737l-7.795-7.785a.679.679,0,0,1-.2-.474v-8.332a.672.672,0,0,1,.67-.67h8.336a.654.654,0,0,1,.469.192l7.713,7.721v.046l.078.077a2.519,2.519,0,0,1,0,3.558l-5.713,5.667A2.506,2.506,0,0,1,17638.271,9060.5Zm-8.434-16.663h0v7.395l7.594,7.583a1.186,1.186,0,0,0,1.668,0l5.721-5.716a1.154,1.154,0,0,0,.342-.825,1.192,1.192,0,0,0-.342-.843l-7.594-7.594Zm3.5,4.629a1.13,1.13,0,1,1,1.129-1.13A1.135,1.135,0,0,1,17633.338,9048.465Z",
    transform: "translate(-17628.5 -9042.501)",
    fill: "#a7a7a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconInactive);
export default __webpack_public_path__ + "static/media/tag-icon-inactive.d666cd0819be436b47bf4f92f35efa8c.svg";
export { ForwardRef as ReactComponent };